$('.main__navigation--inner .nav__link__holder-main').hover(function() {
    var $submenuMega = $(this).children('.nav__submenu--mega');

    if ($submenuMega.length > 0) {
        var $verticalLinks = $submenuMega.find('.nav__vertical-links--outer');
        var $navLinkHolder = $submenuMega.find('.nav__featured-products .nav__link__holder--mega');

        if ($verticalLinks.length == 3) {
            if ($navLinkHolder.length > 2)  {
                $navLinkHolder.last().remove();
                $submenuMega.find('.nav__featured-products').addClass('nav__featured-products--2');
            }
        }

        if ($verticalLinks.length > 3) {
            if ($navLinkHolder.length > 1)  {
                $navLinkHolder.slice(-2).remove();
                $submenuMega.find('.nav__featured-products').addClass('nav__featured-products--3');
            }
        }
    }
});
